import type {
  AdvancedGlobalSearchApiProps,
  GetGlobalSearchRecordItemsResponse,
  GlobalSearchRecord,
} from '../../@types/global-search';
import { api } from './api';

export const globalSearchApi = api.injectEndpoints({
  overrideExisting: 'throw',
  endpoints: (builder) => ({
    getAdvancedGlobalSearch: builder.mutation<Array<GlobalSearchRecord>, AdvancedGlobalSearchApiProps>({
      query: ({ page, pageSize, ...rest }) => ({
        url: `/records/global-search?page=${page}&pageSize=${pageSize}`,
        method: 'POST',
        body: rest,
        validateStatus: (response, result) => response.status === 200 && result,
      }),
      transformResponse: (response: GetGlobalSearchRecordItemsResponse) =>
        response.items?.map((item) => ({ ...item, id: item.recordId })) ?? [],
    }),
  }),
});

export const { useGetAdvancedGlobalSearchMutation } = globalSearchApi;
